<template>
	<div class="table-filter-condition-generator">
		<h5 v-if="inputFieldHint" class="desc">{{ inputFieldHint }}</h5>
		<div class="display-flex condition-list" v-if="groupOfConditions && groupOfConditions.type">
			<ConditionTypeIndicator :conditionType="groupOfConditions.type" v-if="!removeOr" />
			<div class="conditions">
				<div v-for="exp in groupOfConditions.conditionList" :key="exp.id">
					<div class="display-flex mb-3">
						<ConditionTypeIndicator :conditionType="exp.type" />
						<div>
							<div v-for="condition in exp.conditionList" :key="condition.id" class="mb-3">
								<component :is="component" v-bind="componentProps(condition)" v-on="componentListeners(condition, exp)" />
							</div>
							<v-btn v-if="!readonly" class="btn btn-xs" @click="addCondition(exp)"> + Add condition</v-btn>
						</div>
					</div>
				</div>
				<div class="display-flex mt-1" v-if="!removeOr">
					<v-btn v-if="!readonly" class="btn btn-xs" @click="addGroupOfConditions()"> + Add group</v-btn>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import TableFilterService from './table-filter-service';

import ConditionTypeIndicator from './ConditionTypeIndicator';

import { previousStepsData } from '@/store/modules/nodes/getters';
import ConditionEditorService from './ConditionEditors/condition-editor-service';
import { replaceInsertDataStringDictionary } from '@/store/modules/selectedWorkflow/getters';
import { configurationsMappingBlocksUUIDs } from '@/store/modules/selectedWorkflow/modules/configurations/getters';

export default {
	name: 'TableFilterConditionGenerator',
	props: {
		rules: { type: Object },
		inputFieldHint: { type: String },
		param: { type: Object },
		node: { type: Object },
		readonly: { type: Boolean },
	},
	components: {
		ConditionTypeIndicator,
	},
	computed: {
		...mapGetters([previousStepsData.fullPath, replaceInsertDataStringDictionary.fullPath, configurationsMappingBlocksUUIDs.fullPath]),
		componentConfig() {
			return ConditionEditorService.getComponentConfig.call(
				this,
				this[previousStepsData.fullPath],
				this[replaceInsertDataStringDictionary.fullPath],
				this[configurationsMappingBlocksUUIDs.fullPath]
			);
		},
		component() {
			return this.componentConfig.component;
		},
		removeOr() {
			return !!this.param.is_join;
		},
	},
	methods: {
		updateCondition(/*condition, newCondition*/) {
			// console.log('**** TableFilterConditionGenerator::onChange: ', condition, newCondition);
			this.$emit('onChange', this.groupOfConditions);
		},
		removeCondition(groupOfConditions, exp, conditionId) {
			TableFilterService.removePredicateFromConditionGroup(groupOfConditions, exp, conditionId);
			this.$emit('onChange', this.groupOfConditions);
		},
		addGroupOfConditions() {
			TableFilterService.addConditionGroup(this.groupOfConditions);
		},
		addCondition(exp) {
			TableFilterService.addPredicateToConditionGroup(exp);
		},
		componentProps(condition) {
			return { ...this.componentConfig.props, conditionGroup: condition };
		},
		componentListeners(condition, exp) {
			return {
				...this.componentConfig.listeners,
				onUpdate: (newCondition) => this.updateCondition(condition, newCondition),
				removeOption: (conditionId) => this.removeCondition(this.groupOfConditions, exp, conditionId),
			};
		},
	},
	mounted() {
		this.groupOfConditions = this.rules || TableFilterService.getInitialTableFilterObj();
	},
	data: () => ({
		groupOfConditions: null,
	}),
};
</script>

<style scoped lang="scss">
.table-filter-condition-generator {
	padding: 15px 5px;
	border: 1px solid #dfe4ef;
	border-radius: 9px;
	.desc {
		padding: 0px 0px 6px 8px;
		white-space: pre;
	}
}
</style>
